import styled from 'styled-components';
import { AllieColors } from '../../../common/color.types';
import { AllieChip } from '../../../components';

export const IconContainer = styled.div<{ color: AllieColors }>`
  color: ${({ color }) => `var(--allie-color-${color})`};
  display: flex;
  align-items: center;

  svg {
    height: 14px;

    path {
      stroke: ${({ color }) => `var(--allie-color-${color})`};
    }
  }
`;

export const StyledLineStatusChip = styled(AllieChip)`
  height: 21px;
  box-sizing: border-box;
  margin: 0;
  --padding-top: 2px;
  --padding-bottom: 2px;
  --padding-start: 6px;
  --padding-end: 6px;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 6px;
  padding-right: 6px;
  display: flex;
  gap: var(--allie-spacing-xs);
`;
